import store from '../../store';
import { genericHandlerError, getWithAxios } from '../../services/commonServices';
import Amplify, { Auth } from 'aws-amplify';
import { AWS_CONFIG } from '../../aws-config/aws-config';
import { axiosInstance } from '../../utils/axiosInstance';
import cogoToast from 'cogo-toast';
Amplify.configure(AWS_CONFIG);

export const SIGN_IN_UP_ACTIONS = {
  SHOW_SIGN_IN_UP: 'SHOW_SIGN_IN_UP',
  HIDE_SIGN_IN_UP: 'HIDE_SIGN_IN_UP',
  SET_USER: 'SET_USER',
  SET_URBAIN_USER: 'SET_URBAIN_USER',
  SET_POSSIBLE_NEW_USER: 'SET_POSSIBLE_NEW_USER',
  SHOW_SIGN_CONFIRM: 'SHOW_SIGN_CONFIRM'
};

export const setShowConfirm = (show: boolean) => {
  return {
    type: SIGN_IN_UP_ACTIONS.SHOW_SIGN_CONFIRM,
    data: show
  };
};

export const setShowSignInUp = (signUp?: boolean) => {
  return {
    type: SIGN_IN_UP_ACTIONS.SHOW_SIGN_IN_UP,
    data: { login: !signUp, signUp: !!signUp }
  };
};

export const setHideSignInUp = () => {
  return {
    type: SIGN_IN_UP_ACTIONS.SHOW_SIGN_IN_UP,
    data: { login: false, signUp: false }
  };
};

export const setUser = (user: any) => {
  return {
    type: SIGN_IN_UP_ACTIONS.SET_USER,
    data: user
  };
};

export const setUrbainUser = (user: any) => {
  return {
    type: SIGN_IN_UP_ACTIONS.SET_URBAIN_USER,
    data: user
  };
};

export const setPossibleNewUser = (user: any) => {
  return {
    type: SIGN_IN_UP_ACTIONS.SET_POSSIBLE_NEW_USER,
    data: user
  };
};

export function signUpUser(data: any) {
  return async (dispatch: any, getState: any) => {
    try {
      await Auth.signUp({
        username: data.email,
        password: data.password,
        attributes: {
          name: `${data.firstName} ${data.lastName}`
        }
      });
      dispatch(setPossibleNewUser(null));
      cogoToast.success('User successfully created, please confirm your user and login.');
      dispatch(setShowConfirm(true));
      dispatch(setShowSignInUp(true));
    } catch (error) {
      console.log('error signing up:', error);
    }
  };
}

export const logOutUser = () => {
  return (dispatch: any) => {
    try {
      window.localStorage.setItem('redirectUrl', window.location.pathname + window.location.search);
      Auth.signOut().then(() => {
        dispatch(setUser(null));
      });
    } catch (error) {
      console.log('error signing out: ', error);
    }
  };
};

export const setOwnUser = (userId: string) => {
  return (dispatch: any) => {
    try {
      if (userId) {
        axiosInstance.get(`/profile/${userId}`).then((usr: any) => {
          dispatch(setUrbainUser(usr.data));
        });
      } else {
        dispatch(setUrbainUser(null));
      }
    } catch (error) {
      console.log('error getting urbain user: ', error);
    }
  };
};
